import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_vm.themeCode === _vm.$enum.common.NotPermission.INTERNAL_TEST_USER ? _c('my-result', {
    attrs: {
      "result-data": _vm.data
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', [_vm._v(_vm._s(_vm.t('对不起，您不是内测用户，暂时不能登录GD系统。')))]), _c('p', {
    staticClass: "mt-10"
  }, [_vm._v(_vm._s(_vm.t('请使用原系统登录页面登录继续操作。')))]), _c('div', [_c('a-button', {
    attrs: {
      "type": "primary",
      "id": "403_to_old_sys",
      "fbu-analyse-name": $t("\u8FD4\u56DE\u539F\u7CFB\u7EDF\u767B\u5F55")
    },
    on: {
      "click": _vm.handleReturnOldSys
    }
  }, [_vm._v(_vm._s(_vm.t('返回原系统登录')))])], 1)])]) : _c('my-result', {
    attrs: {
      "result-data": _vm.data
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', [_vm._v(_vm._s(_vm.t('对不起，你当前登录的账号无基础权限。')))]), _c('p', {
    staticClass: "mt-10"
  }, [_vm._v(_vm._s(_vm.t('请联系账号管理员（主账号）协助设置权限。')))]), _c('div', [_c('a-button', {
    attrs: {
      "type": "primary",
      "id": "403_logout",
      "fbu-analyse-name": $t("\u9000\u51FA\u767B\u5F55")
    },
    on: {
      "click": _vm.handleLogout
    }
  }, [_vm._v(_vm._s(_vm.t('退出登录')))])], 1)])])], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };